import React, { Component } from "react";
import { Redirect, BrowserRouter as Router, NavLink } from "react-router-dom";
import Config from "../../config";
import {
  Pagination,
  Row,
  Col,
  Spin,
  Modal as modal,
  Space as space,
  Button as button,
  Modal,
  Card,
  Radio,
  Button,
  notification,
} from "antd";
import UserTable from "./userListTable";
import $ from "jquery";
import PreviousIcon from "../AuthUsers/PreviousIcon.png";
import NextIcon from "../AuthUsers/NextIcon.png";
import "./ListUser.css";
import { updateUserList } from "../../store/broadcaster/BroadcastRegister";
import AddUserRegistration from "../UserRegistration/AddUser";
import EditUserInformation from "../UserRegistration/EditUser";
import CreateTicket from "../TicketManagement/CreateTicket/CreateTicket";
import AdduserLogo from "../images/Adduserroute.svg";
import PrimaryButton from "../CommonComponent/Buttons/PrimayButton";

class ListUser extends Component {
  dispStatus = "block";
  constructor() {
    super();
    this.state = {
      Fromwhere: "User Management",
      TicketShow: false,
      updateTable: "",
      showPagination: true,
      listTableKey: 1,
      ComponentKey: 1,
      // updateUserTable: 1,
      currentPage: 1,
      todosPerPage: 1,
      rowsPerPage: 0,
      upperPageBound: 5,
      lowerPageBound: 0,
      isPrevBtnActive: "disabled",
      isNextBtnActive: "",
      totalRecords: 0,
      limit: 100,
      headers: [],
      loader2: true,
      ListUser: [],
      DisplayType: "List",
      EditUserData: [],
      UserName: null,
      Email: null,
      ApprovedBy: null,
      CreatedDate: null,
      PhoneNumber: null,
      Address: null,
      Roles: null,
      ActiveTab: "ActiveUsers",
      RegistrationID: 0,
      loader: true,
      disableTab: false,
      multiRowSelec: [],
      accessScreen: false,
      isEligibilityOnly: false,
      isAdmin: false,

      isAccessLoading: false,
      
      deletedSingleUser:false,

      showRegisteredSelectAllButt:false,
      showActiveUserListButt:false

    };
    // console.log("sdsdsd",this.props);

    updateUserList.subscribe((message) => {
      // console.log("EditEncounter --- ", message);
      if (message === "update" || message === "deactivate") {
        if (message === "deactivate") {
          // this is to render table again so that we have have latest list of users
          this.setState({ ComponentKey: this.state.ComponentKey + 1 });
        }
        this.getListUser("ActiveUsers");
      }
    });
  }

  handleshowPagination = (value) => {
    this.setState({ showPagination: value });
  };
  onPageChange = (page) => {
    this.getListUser(this.state.ActiveTab, page);
    // this.setState({ currentPage: page })
  };

  resetFilter = () => {
    this.setState(
      {
        ListUser: [],
        currentPage: 1,
        UserName: null,
        Email: null,
        ApprovedBy: null,
        CreatedDate: null,
        PhoneNumber: null,
        Address: null,
        Roles: null,
        ComponentKey: this.state.ComponentKey + 1,
      },
      () => this.getListUser("ActiveUsers")
    );
  };

  DeleteUserCallBack = (page) => {
    // console.log('page prop',page)
    // console.log('page state', this.state.currentPage)
    this.setState({ currentPage: page,deletedSingleUser:true }, () => {
      this.resetFilter();
      //this.getListUser(page, null);
      
    });
  };
  TicketShowInfo = () => {
    this.setState((state) => ({ TicketShow: true }));
  };
  TicketHideInfo = () => {
    this.setState((state) => ({ TicketShow: false }));
  };

  onSelectRow = (data) => {
    let temp = [...this.state.multiRowSelec]

    if(temp.includes(data)){
      temp = temp.filter(i => {
        return i !== data
      })
    }
    else{
      temp.push(data)
    }

    this.setState({
      multiRowSelec: [...temp]
    })
  }


  handleUpdateSelectedRows = (rows) => {
    console.log(rows)
    this.setState({ multiRowSelec: [...rows] });
  };
  resetSelectedRows = () => {
    this.setState({
      multiRowSelec: []
    })
  }

  getListUser = async (page, e = 1, SearchGlobal = null) => {
    this.setState({ 
      showPagination: false, 
      ListUser: [], 
      updateTable: "", 
      loader2: true, 
      disableTab: true,
      //loader: true
    });
    let roles = sessionStorage.getItem("rolename");
    if(this.state.ActiveTab !== page){
      this.state.UserName = null;
      this.state.Email = null;
      this.state.ApprovedBy = null;
      this.state.CreatedDate = null;
      this.state.PhoneNumber = null;
      this.state.Roles = null;
    }
    let formatToISODate = (dateString) => {
      if (!dateString) return "";
    
      const [month, day, year] = dateString.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    };
    let userData = {
      taxidNPIs: [],
      IPAName:[],
      ProviderNPI:null,
      ProviderTaxID:null,
      planName:sessionStorage.getItem("planName"),
      IsUseradminRole:"",
      SecondaryRole:"",
      taxstoredData:[],
      taxId:[],
      startIndex: e,
      limit: this.state.limit,
      Name: this.state.UserName,
      Email: this.state.Email,
      ApprovedBy: this.state.ApprovedBy,
      ApprovedDate: formatToISODate(this.state.CreatedDate),
      Phone: this.state.PhoneNumber,
      role: this.state.Roles,
    };

    // if(page !== this.state.ActiveTab) {
    //   this.resetFilter();
    // }

    //let userRoles = "";
    if (roles.includes("User Admin")){
    userData.IsUseradminRole = 'User Admin'
    let rolesArr = roles.split(",");

    userData.SecondaryRole =  rolesArr.filter((item) => item != "User Admin")[0]
    }

    

    if (roles && (roles.includes("Group User") || roles.includes("IPA User"))) {
      userData.taxidNPIs = JSON.parse(
        sessionStorage.getItem("taxidNpiMapping")
      );


      const ipaList =
        sessionStorage.getItem("IPAList")
          ?.split('","')
          .map(item => item.replace(/^"|"$/g, "").trim()) || [];

      console.log(ipaList);

      userData.IPAName = ipaList;
      

      
    }

    let providerDetails = "";
    if (sessionStorage.getItem("ProviderRole") === "PROVIDER") {
      const npiStoredData = JSON.parse(
        sessionStorage.getItem("npivalue") || "[]"
      );
      
      const taxStoredData = JSON.parse(
        sessionStorage.getItem("taxid") || "[]"
      );
      
      userData.ProviderNPI =
      Array.isArray(npiStoredData) && npiStoredData.length > 0
        ? npiStoredData.join(",")
        : null;
    
    userData.ProviderTaxID =
      Array.isArray(taxStoredData) && taxStoredData.length > 0
        ? taxStoredData.join(",")
        : null;
    }

     console.log(userData)

      //  ?PlanName=${sessionStorage.getItem(
        //   "planName"
        // )}${providerDetails}${userRoles}`,

    let response;
    if (page === "ActiveUsers") {
      this.state.ActiveTab = "ActiveUsers";
      // response = await fetch(
      //   `${Config.api}/GetAllUserInfo?PlanName=${sessionStorage.getItem(
      //     "planName"
      //   )}${providerDetails}${userRoles}`,
      response = await fetch(
        `${Config.api}/GetAllUserInfo`,
    
        {
          method: "POST",
          headers: {
            Authorization: sessionStorage.getItem("access_token"),
            Accept: "application/json",
            "Content-type": "application/json",
          },
          body: JSON.stringify(userData),
        }
      );

      response = await response.json();
      // response = {};
      if (response.UsersList && response.UsersList.length > 0) {
        const updatedListUser = response.UsersList.map(user => {
          const IPATaxMappings = user.IPATaxMappings || []; // Add null check here
          return {
            ...user,
            IPATaxMappings: IPATaxMappings.map(mapping => `${mapping.IPA}: ${mapping.TaxList}`),
          };
        });
        this.setState({
          headers: Object.keys(response.UsersList[0]).map((key) => {
            return {
              title: key,
              displayName: Config.userDetails[key]?.displayName,
              display:
                Config.userDetails &&
                Config.userDetails[key] &&
                Config.userDetails[key].display
                  ? true
                  : false,
              filterType:
                           Config.userDetails[key]?.displayName === "Date of Approval"
                           ? "date"
                           : Config.userDetails[key]?.filterType || "text",

            };
          }),
          loader: false,
          disableTab: false,
          ListUser: updatedListUser,
          loader2: false,
          totalRecords: response.TotalNumberOfRec,
          currentPage: e,
          updateTable: SearchGlobal,
          deletedSingleUser:false,
          showPagination:
          response.TotalNumberOfRec > this.state.limit ? true : false,
          showRegisteredSelectAllButt:false,
          showActiveUserListButt:false,
          multiRowSelec:[],
          // ComponentKey: this.state.ComponentKey + 1

          // rowsPerPage: Math.round(response.TotalNumberOfRec / 3)
          EligibilityOnlyFlag: response.UsersList[0].EligibilityOnlyFlag,
        });
      } else {
        this.setState({
          disableTab: false,
          loader2: false,
          loader: false,
          headers: [],
          ListUser: [],
          currentPage: e,
          updateTable: SearchGlobal,
          showPagination: false,
          multiRowSelec:[],
          showRegisteredSelectAllButt:false,
          showActiveUserListButt:false
        });
      }
    }
    if (page === "RegisteredUsers") {
      let tenantId = sessionStorage.getItem("Tanent");
      this.state.ActiveTab = "RegisteredUsers";
      let taxIDs = [];
      const roles = sessionStorage.getItem('rolename');
      // if (roles.includes('Group')){
      //   JSON.parse(sessionStorage.getItem('taxidNpiMapping'))
      //   .forEach(map => taxIDs.push(map.TaxID))
      // }
      response = await fetch(
        `${Config.api}/GetRegisteredIPAUserList`,
        {
          method: "POST",
          headers: {
            Authorization: sessionStorage.getItem("access_token"),
            Accept: "application/json",
            "Content-type": "application/json",
          },
          body : JSON.stringify({
            TenantID: tenantId,
            TaxIDs: taxIDs,
            Roles: roles
          })
        }
      );

      response = await response.json();
      response = [...response].reverse()

      console.log(response)
      response = this.removeduplicateTaxid(response);

      // response = {};

      if (response && response.length > 0) {
        let headers = [{
          title: 'Select',
          displayName: '',
          display: true,
          filterType: null,
        }]
        Object.keys(response[0]).forEach((key) => {
          headers.push({
            title: key,
            displayName: Config.ipaUsers[key].displayName,
            display:
              Config.ipaUsers &&
              Config.ipaUsers[key] &&
              Config.ipaUsers[key].display
                ? true
                : false,
            filterType: Config.ipaUsers[key].filterType || "text",
          });
        })
        this.setState({
          headers: headers,
          disableTab: false,
          loader: false,
          ListUser: response,
          currentPage: e,
          updateTable: SearchGlobal,
          showPagination: false,
          loader2: false,
          showRegisteredSelectAllButt:true,
          showActiveUserListButt:true
          // ComponentKey: this.state.ComponentKey + 1

          // rowsPerPage: Math.round(response.TotalNumberOfRec / 3)
        });
      } else {
        this.setState({
          disableTab: false,
          headers: [],
          ListUser: [],
          multiRowSelec:[],
          currentPage: e,
          loader: false,
          updateTable: SearchGlobal,
          showPagination: false,
          loader2: false,
          showRegisteredSelectAllButt:false,
          showActiveUserListButt:false,
        });
      }
    }
    this.setState({ 
      //loader: false, 
      loader2: false 
    });
    $("ul li.active").removeClass("active");
    $("ul li#" + e).addClass("active");
    
  };

  removeduplicateTaxid = (data) => {
    return data.map(item => {
      if (item.TaxID) {
  
        const uniqueTaxIds = [
          ...new Set(
            item.TaxID
              .split(",")
              .map(id => id.trim())
              .filter(id => id)
          )
        ];
  
        return {
          ...item,
          TaxID: uniqueTaxIds.join(", ")
        };
      }
  
      return item;
    });
  };
  componentDidMount() {
    this.getListUser("ActiveUsers");
  }

  GetDisplayTye = async (value, Data) => {
    this.setState({
      loader: true,
      ListUser: [],
      UserName: "",
      Email: "",
      ApprovedBy: "",
      PhoneNumber: "",
      Roles: "",
    });
    if (
      this.state.ActiveTab !== "RegisteredUsers" &&
      Data !== "RegisteredUser" &&
      value !== "List"
    ) {
      this.setState({
        DisplayType: value,
        EditUserData: Data,
      });
    } else if (this.state.ActiveTab === "RegisteredUsers" && value === "Form") {
      this.setState({
        DisplayType: value,
        EditUserData: Data,
      });
    } else if (value === "List") {
      this.setState({
        DisplayType: value,
        EditUserData: Data,
      });
      this.getListUser(this.state.ActiveTab);
    } else {
      this.state.RegistrationID =
        this.state.RegistrationID !== 0
          ? this.state.RegistrationID
          : (this.state.RegistrationID = Data.RegistrationID);
      // this.state.RegistrationID = Data.RegistrationID;
      let response = await fetch(
        `${Config.api}/GetRegisteredIPAUserRecord?registrationID=${Data.RegistrationID}`,
        {
          method: "GET",
          headers: {
            Authorization: sessionStorage.getItem("access_token"),
            Accept: "application/json",
            "Content-type": "application/json",
          },
        }
      );

      response = await response.json();
      if (response && Data === "RegisteredUser") {
        this.setState({
          DisplayType: "List",
        });
        this.getListUser("RegisteredUsers");
      } else if (response) {
        this.setState({
          DisplayType: "edit",
          EditUserData: response,
          RegistrationID: Data.RegistrationID,
          loader: false
        });        
      }
    }
  };

  handleSetField = (name, fieldValue) => {
    let value = fieldValue == "" ? null : fieldValue;

    this.setState({ [name]: value });

    // if(name === 'UserName'){
    //   this.setState({UserName: value}, () => console.log(this.state))
    // }
    // if(name === 'Email'){
    //   this.setState({Email: value}, () => console.log(this.state))
    // }
    // if(name === 'PhoneNumber'){
    //   this.setState({PhoneNumber: value}, () => console.log(this.state))
    // }
    // if(name === 'Address'){
    //   this.setState({Address: value}, () => console.log(this.state))
    // }
    // if(name === 'Roles'){
    //   this.setState({Roles: value}, () => console.log(this.state))
    // }
  };

  openBulkAccessScreen = () => {
    this.setState({
      accessScreen: true
    })
  }

  checkUserRole = (role) => {
    let userRoles = sessionStorage.getItem("rolename");
    return userRoles.includes(role);
  };

  handleIPASubmit = async (button) => {
    this.setState({
      isAccessLoading: true
    }, async () => {
      let body = {
        RegistrationIDs: this.state.multiRowSelec.map(row => {
          return {
            ID: row.RegistrationID
          }
        }),
        PlanName: sessionStorage.getItem("planName"),
        Status: button,
        IsUserAdmin: this.state.isAdmin,
        IsEligibilityOnly: this.state.isEligibilityOnly,
        ApprovedBy: sessionStorage.getItem("userEmail"),
      };
      body = await JSON.stringify(body);
  
      let response = await fetch(`${Config.api}/UpdateIPAUserStatus`, {
        method: "PUT",
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
          Accept: "application/json",
          "Content-type": "application/json",
        },
        body: body,
      });
  
      response = await response.json();
  
      if (response) {
        notification.open({
          description: response.Message,
        });
      }
      this.setState({
        isAccessLoading: false,
        accessScreen: false,
        multiRowSelec: [],
        isAdmin: false,
        isEligibilityOnly: false
      }, () => {
        this.getListUser("RegisteredUsers")
      });
    })
  };

  render() {
    const isPlanCsh = sessionStorage.getItem("planName") === "csh";
    const isPlanDemo = sessionStorage.getItem("planName") === "demo";
    const TicketHideInfo = () => {
      this.setState((state) => ({ TicketShow: false }));
    };
    const windowDimensions = "height="+window.screen.height+",width="+window.screen.width;
    const warning = () => {
      modal.confirm({
        title: "Are you sure to cancel",
        content: "cancel will discard all the added data",
        onOk() {
          TicketHideInfo();
        },
        okText: "Yes, Cancel",
        cancelText: "No",
      });
    };
    const CancelButton = () => (
      <space wrap>
        <button className="button-cancel" onClick={warning}>
          Cancel
        </button>
      </space>
    );
    return (
      <div>
        {
          this.state.accessScreen &&
          <Modal
            title="Permissions"
            open={this.state.accessScreen}
            onOk={null}
            onCancel={() => {this.setState({
              accessScreen: false
            })}}
            cancelButtonProps={null}
            width={840}            
            footer={[
              <>{
                this.state.isAccessLoading ?
                <span className="ml-2">
                  <Spin size="small" />
                </span>:
                <>
                  <button
                    className="cancle-button pl-4 pr-4"
                    onClick={() => this.handleIPASubmit("Denied")}
                    htmlType="submit"
                  >
                    Deny
                  </button>,
                  <button
                    htmlType="submit"
                    className="ml-3 butto-alluser pl-4 pr-4"
                    onClick={() => this.handleIPASubmit("Approved")}
                  >
                    Approve
                  </button>
                </>
              }</>
            ]}
          >
            {
              this.checkUserRole("Plan Admin") &&
              <Card className="card-css pl-2 pr-2 pt-1 pb-1 mb-3">
                <Row>
                  <Col span={20} className="question-css">
                    01. Do you want to assign User-Admin privileges to the
                    user ?<span style={{ color: "#D14A4A" }}>*</span>
                  </Col>
                  <Col span={4} style={{ textAlign: "right" }}>
                    <Radio.Group
                      onChange={(e) => {
                        this.setState({
                          isAdmin: e.target.value
                        })
                      }}
                      value={this.state.isAdmin}
                    >
                      <Radio
                        value={true}
                        className="question-css"
                        disabled={!this.checkUserRole("Plan Admin")}
                      >
                        Yes
                      </Radio>
                      <Radio
                        value={false}
                        className="question-css"
                        disabled={!this.checkUserRole("Plan Admin")}
                      >
                        No
                      </Radio>
                    </Radio.Group>
                  </Col>
                </Row>
              </Card>
            }
            {
              this.checkUserRole("Plan Admin") && (
                <Card className="card-css pl-2 pr-2 pt-1 pb-1">
                  <Row>
                    <Col span={10} className="question-css">
                      {!this.checkUserRole("Plan Admin") ? "01. " : "02. "}{" "}
                      Should the user have Eligibility Only permissions ?{" "}
                      <span style={{ color: "#D14A4A" }}>*</span>
                    </Col>
                    <Col span={14} style={{ textAlign: "right" }}>
                      <Radio.Group
                        onChange={(e) => {
                          this.setState({
                            isEligibilityOnly: e.target.value
                          })
                        }}
                        value={this.state.isEligibilityOnly}
                      >
                        <Radio value={true} className="question-css">
                          Yes
                        </Radio>
                        <Radio value={false} className="question-css">
                          No
                        </Radio>
                      </Radio.Group>
                    </Col>
                  </Row>
                  <span
                    style={{
                      color: "orange",
                      padding: "2px",
                      fontSize: "12px",
                    }}
                  >
                    Setting this user permission as "Yes" will enable access
                    to Eligibility Check page only and <br />
                    user will be restricted from access any other
                    information on the website apart from member's
                    eligibility.
                  </span>
                </Card>
              )
            }            
          </Modal>
        }
        {this.state.DisplayType === "Form" ? (
          <AddUserRegistration getType={this.GetDisplayTye} />
        ) : this.state.DisplayType === "edit" ? (
          <EditUserInformation
            RegistrationID={this.state.RegistrationID}
            activeTab={this.state.ActiveTab}
            getType={this.GetDisplayTye}
            userData={this.state.EditUserData}
          />
        ) : this.state.TicketShow == true && !isPlanDemo && !sessionStorage.getItem("planName") === "csh" ? (
          // <div>
          //   <div className="square-blue-profile-listuser">
          //     <Row
          //       className="ml-4"
          //       type="flex"
          //       justify-content="space-start"
          //       align="middle"
          //       style={{ padding: "10px" }}
          //     >
          //       <Col>
          //         <div
          //           style={{
          //             color: "white",
          //             fontSize: "18px",
          //             fontWeight: "bold",
          //             // width: "170px",
          //           }}
          //         >
          //           Create a Ticket
          //         </div>
          //         {/* <div style={{color:'white'}}>Enter Details to check the Eligibility of Members</div>      */}
          //       </Col>
          //     </Row>
          //   </div>
          //   <div className="square-white-profile-listuser ml-4">
          //     <CreateTicket TicketHideInfo={this.TicketHideInfo} Fromwhere={this.state.Fromwhere}/>
          //   </div>
          // </div>
          console.log("create ticket button")
        ) : (
          <div>
            <div className="square-blue-profile-listuser" >
              <Row
                className="ml-4"
                type="flex"
                justify-content="space-start"
                align="middle"
                style={{ padding: "10px" }}
              >
                <Col>
                  <div
                    style={{
                      color: "white",
                      fontSize: "18px",
                      fontWeight: "bold",
                      paddingTop: "18px",
                      display:"inline-flex"
                      // width: "170px",
                    }}
                  >
                    User search
                  </div>
                  {/* <div style={{color:'white'}}>Enter Details to check the Eligibility of Members</div>      */}
                </Col>
                <Col push={sessionStorage.getItem("planName") === 'solis'? 8 : 18} className= {"ml-4"}>
                  {/* <NavLink to="/AddUser">
             </NavLink> */}
                  <Row>
                    <Col className="ml-1">
                    <button
                      className="button-decorator-listuser button-text-color1 button-text-common"
                      onClick={() => this.GetDisplayTye("Form")}
                    >
                      <img src={AdduserLogo} /> Add User
                    </button>
                    </Col>
                    {
                      sessionStorage.getItem("planName") === 'solis'&&
                      <Col className="ml-1">
                      <button 
                        className="button-decorator-listuser button-text-color1 button-text-common"
                        onClick={() => {
                        window.open(
                          Config.OTC,
                          "OTC Portal",
                          windowDimensions
                        );
                      }}>OTC Portal</button>
                      </Col>
                    }
                    {
                      sessionStorage.getItem("planName") === 'solis'&&
                      <Col className="ml-1">
                      <button 
                        className="button-decorator-listuser button-text-color1 button-text-common"
                        onClick={() => {
                        window.open(
                          Config.CalypsoLite,
                          "Calypso Lite",
                          windowDimensions
                        );
                      }}>Calypso Lyte</button>
                      </Col>
                    }
                    {
                      sessionStorage.getItem("planName") === 'solis'&&
                      <Col className="ml-1">
                      <button 
                        className="button-decorator-listuser button-text-color1 button-text-common"
                        onClick={() => {
                        window.open(
                          Config.EnsureDataSolutions,
                          "Ensure Data Solutions",
                          windowDimensions
                        );
                      }}>Ensure Data Solutions</button>
                      </Col>
                    }
                    {
                      sessionStorage.getItem("planName") === 'solis'&&
                      <Col className="ml-1">
                      <button 
                          className="button-decorator-listuser button-text-color1 button-text-common"
                          onClick={() => {
                          window.open(
                            Config.SolisHealthPlan,
                            "Solis Health Plan",
                            windowDimensions
                          );
                        }}>Solis Health Plans</button>
                      </Col>
                    }
                  </Row>
                  
                  
                  
                  { !sessionStorage.getItem("planName") === "csh" &&
                  <button
                    className="button-decorator-listuser button-text-color1 button-text-common"
                    onClick={() => this.TicketShowInfo()}
                  >
                    Create a Ticket
                  </button> }
                  
                </Col>
              </Row>
            </div>
            <div className="square-white-profile-listuser ml-4">
              {sessionStorage.getItem("AdminRole") === "User Admin" &&
              sessionStorage.getItem("PlanAdminRole") === "Plan Admin" && (
                  <Row>
                    <Col span={3}>
                    <PrimaryButton  
                      disabled={this.state.disableTab}
                      className={this.state.ActiveTab === "ActiveUsers" ? "details-tab" : "simple-button"}
                      onClick={() => this.getListUser("ActiveUsers")} 
                      label={"Active Users"} />
                      {/* <button
                        className={
                          this.state.ActiveTab === "ActiveUsers"
                            ? "details-tab"
                            : "simple-button"
                        }
                        onClick={() => this.getListUser("ActiveUsers")}
                      >
                        Active Users
                      </button> */}
                    </Col>
                    <Col span={3}>
                      {" "}
                      <PrimaryButton  
                        disabled={this.state.disableTab}
                        className={this.state.ActiveTab === "RegisteredUsers" ? "details-tab" : "simple-button"} 
                        onClick={() => this.getListUser("RegisteredUsers")} 
                        label={"Register Users-Pending Approval"} />
                      {/* <button
                        className={
                          this.state.ActiveTab === "RegisteredUsers"
                            ? "details-tab"
                            : "simple-button"
                        }
                        onClick={() => this.getListUser("")}
                      >
                        Registered Users
                      </button> */}
                    </Col>
                  </Row>
                )}
              <Row
                className="ml-5"
                type="flex"
                justify-content="space-start"
                align="middle"
                style={{ padding: "10px" }}
              >
                <Col pull={7}>
                  {this.state.ListUser.length > 0 &&
                    this.state.ActiveTab !== "RegisteredUsers" && (
                      <div
                        // style={{ float: "left" }}
                        className="mt-2 mr-5 pt-2 total-lenth"
                      >
                        {this.state.totalRecords}{" "}
                        {this.state.totalRecords <= 1
                          ? "User Found"
                          : "Users Found"}
                      </div>
                    )}
                </Col>
              </Row>

              <div>
                {!this.state.loader && (
                  <UserTable
                    onOpenModal={this.openBulkAccessScreen}
                    resetSelectedRows = {this.resetSelectedRows}
                    onSelectRow={this.onSelectRow}
                    onUpdateSelectedRows={this.handleUpdateSelectedRows}
                    selectedRows={this.state.multiRowSelec}
                    activeTab={this.state.ActiveTab}
                    updateTable={this.state.updateTable}
                    key={this.state.ComponentKey}
                    ListUser={this.state.ListUser}
                    loader2={this.state.loader2}
                    getListUser={this.getListUser}
                    handleSetField={this.handleSetField}
                    tableData={this.state.ListUser}
                    headers={this.state.headers}
                    getType={this.GetDisplayTye}
                    currentPage={this.state.currentPage}
                    limit={this.state.limit}
                    resetFilter={this.resetFilter}
                    handleshowPagination={this.handleshowPagination}
                    DeleteUserCallBack={this.DeleteUserCallBack}

                    deletedSingleUser={this.state.deletedSingleUser}

                    showRegisteredSelectAllButt={this.state.showRegisteredSelectAllButt}
                    showActiveUserListButt={this.state.showActiveUserListButt}


                  />
                )}
              </div>

              {this.state.loader && (
                <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
                  <Spin size="large" tip="Loading..." />
                </div>
              )}

              {this.state.totalRecords > this.state.limit &&
              this.state.ActiveTab !== "RegisteredUsers" &&
              this.state.showPagination ? (
                <div>
                  <Pagination
                    defaultCurrent={1}
                    total={this.state.totalRecords}
                    onChange={this.onPageChange}
                    hideOnSinglePage={true}
                    current={this.state.currentPage}
                    // defaultPageSize={this.state.limit}
                    pageSize={this.state.limit}
                    showSizeChanger={false}
                  />
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default ListUser;